// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back[data-v-b83da69a] {\n  width: 0.74667rem;\n  height: 0.74667rem;\n}\n.back .icon[data-v-b83da69a] {\n  width: 0.32rem;\n  height: 0.32rem;\n  border: 0.05333rem solid transparent;\n  transform: rotate(45deg);\n}\n", ""]);
// Exports
module.exports = exports;
